import { LoadingStatusEnum } from '../../../store/types'
import { AIMarketInsightsState } from '../api/types'

const initialState: AIMarketInsightsState = {
  symbols: {
    list: [],
    loading: LoadingStatusEnum.Idle,
  },
  news: {
    list: [],
    loading: LoadingStatusEnum.Idle,
  },
  dailyAnalysis: {
    list: [],
    loading: LoadingStatusEnum.Idle,
  },
  last7DaysAnalysis: {
    list: [],
    loading: LoadingStatusEnum.Idle,
  },
}

export type StateType = typeof initialState

export default initialState
